import { createSlice } from "@reduxjs/toolkit"

type AuthUser = {
  name?: string
  email?: string
  picture?: string
  sub?: string
}

type AuthState = {
  isAuthenticated: boolean
  isLoading: boolean
  user: AuthUser | null
  accessToken: string | null
  requiresSignIn: boolean
}

const initialState: AuthState = {
  isAuthenticated: false,
  isLoading: true,
  user: null,
  accessToken: null,
  requiresSignIn: false,
}

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthState: (state, action) => {
      const nextUser = action.payload?.user || null
      const nextAuthenticated = Boolean(action.payload?.isAuthenticated)
      const nextLoading = Boolean(action.payload?.isLoading)
      if (nextAuthenticated) {
        state.requiresSignIn = false
      } else if (!nextLoading && (state.isAuthenticated || action.payload?.hasError)) {
        // Do not automatically restart Auth0 after a lost session or failed
        // callback: that can repeat forever when silent authentication fails.
        state.requiresSignIn = true
      }
      if (nextUser?.sub !== state.user?.sub) state.accessToken = null
      state.isAuthenticated = nextAuthenticated
      state.isLoading = nextLoading
      state.user = nextUser
    },
    setAccessToken: (state, action) => {
      state.accessToken = action.payload ? String(action.payload) : null
    },
    clearAccessToken: (state) => {
      state.accessToken = null
    },
    clearAuthState: (state) => {
      state.isAuthenticated = false
      state.isLoading = false
      state.user = null
      state.accessToken = null
      state.requiresSignIn = false
    },
  },
})

export const { setAuthState, setAccessToken, clearAccessToken, clearAuthState } = authSlice.actions
export default authSlice.reducer
